(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blocksy-about-us"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const accordionItems = document.querySelectorAll('.blocksy-accordion-item');
    const blockContents = document.querySelectorAll('.blocksy-block-content');
    const firstAccordion = accordionItems[0];
    const firstContent = blockContents[0];

    accordionItems.forEach((item) => {
      const header = item.querySelector('.blocksy-accordion-header');
      const content = item.querySelector('.blocksy-accordion-content');

      header.addEventListener('click', () => {
        const id = item.dataset.block;
        const isActive = item.classList.contains('active');

        accordionItems.forEach((i) => {
          i.classList.remove('active');
          const c = i.querySelector('.blocksy-accordion-content');
          if (c) c.style.maxHeight = null;
        });

        blockContents.forEach((c) => c.classList.remove('active'));

        if (!isActive) {
          item.classList.add('active');
          const contentHeight = content.scrollHeight;

          if (contentHeight > 180) {
            content.style.maxHeight = '180px';
            content.style.overflowY = 'auto';
          } else {
            content.style.maxHeight = contentHeight + 'px';
            content.style.overflowY = 'hidden';
          }

          const leftContent = document.querySelector(`.blocksy-block-content[data-block="${id}"]`);
          if (leftContent) leftContent.classList.add('active');
        } else {
          if (firstAccordion && firstContent) {
            firstAccordion.classList.add('active');
            const firstAccContent = firstAccordion.querySelector('.blocksy-accordion-content');
            const firstHeight = firstAccContent.scrollHeight;

            if (firstHeight > 180) {
              firstAccContent.style.maxHeight = '180px';
              firstAccContent.style.overflowY = 'auto';
            } else {
              firstAccContent.style.maxHeight = firstHeight + 'px';
              firstAccContent.style.overflowY = 'hidden';
            }

            firstContent.classList.add('active');
          }
        }
      });
    });

    if (firstAccordion) {
      const firstAccContent = firstAccordion.querySelector('.blocksy-accordion-content');
      const firstHeight = firstAccContent.scrollHeight;

      if (firstHeight > 180) {
        firstAccContent.style.maxHeight = '180px';
        firstAccContent.style.overflowY = 'auto';
      } else {
        firstAccContent.style.maxHeight = firstHeight + 'px';
        firstAccContent.style.overflowY = 'hidden';
      }
    }
  });

  // For animation
  document.addEventListener('DOMContentLoaded', function () {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      mirror: true,
    });

    // Optional: refresh in case of Swiper or dynamic content
    setTimeout(function () {
      if (window.AOS) AOS.refresh();
    }, 500);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
